module.exports = __webpack_public_path__ + "static/img/file_img.1719bac2.png";